export default "__VITE_ASSET__BAiQySv8__"